import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import {choose} from 'lit/directives/choose.js';

import store from '../../store';
import {conditional} from '../../util/conditional';


@customElement('shared-tender-text-page')
export class SharedTenderTextPage extends connect(store)(LitElement) {

	static styles = css`
		.page-container {
			display: flex;
			margin: var(--specsheet-medium-gap) var(--specsheet-large-gap);

		}

		.image {
			width: 35%;
			max-height: 800px;
		}

		.tenderText {
			font: var(--font-specsheet-light);
			padding-right: 50px;
		}

		@media print {
			.page-container {
				display: flex;
				margin: var(--specsheet-medium-gap) 0;

			}

			.image {
				width: 30%;
			}

			.tenderText {
				font: var(--font-specsheet-light);
				width: 55%;
			}
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.featuremodel = state.featureModel;
		this.productData = state.productData;
		this.status = state.status;
		this.lang = state.status.lang;
		this.lightProfile = state.lightProfile.data;
		this.decisions = state.decisions.data;
		this.conditionalVariantValues = state.productData.conditionalVariantValues;
	}

	c(id) {
		return conditional(this.decisions, this.conditionalVariantValues, id);
	}

	render() {
		const s = this.state;
		return html`
			<div class="page-container">
				<div class="image">
					${choose(
						this.status.family, [
							[
								'LightProfile',
								() => html`
									<light-profile-image></light-profile-image>`
							],
							[
								'TheLine',
								() => html`
									<line-drawing></line-drawing>`
							], [
								'Aeto',
								() => html`
									<svg-aeto-drawing></svg-aeto-drawing>`
							]
						],
						() => html`
						`)
					}
				</div>

				<div class="tenderText">
					${choose(
						this.status.family, [
							[
								'LightProfile',
								() => html`
									<new-light-tender-text></new-light-tender-text>`
							],
							[
								'TheLine',
								() => html`
									<line-tender-text></line-tender-text>`
							], [
								'Aeto',
								() => html`
									<new-solar-tender-text></new-solar-tender-text>`
							]
						],
						() => html`
							<new-avanza-tender-text></new-avanza-tender-text>
						`)
					}
				</div>
			</div>
		`;
	}
}
